import clsx from "clsx";
import { type ForwardedRef } from "react";
import { LoadingSkeleton } from "shared-components";

interface Props {
  expandableTextSettings: null | { isExpanded: boolean };
  toggleExpand: () => void;
  text?: string;
  loading?: boolean;
  className?: string;
  isDesktopExpandable?: boolean;
  ref: ForwardedRef<HTMLParagraphElement>;
}

export const ExpandableText = function ExpandableText({
  loading,
  text,
  expandableTextSettings,
  toggleExpand,
  className,
  isDesktopExpandable,
  ref,
}: Props) {
  const isTextClamped = !expandableTextSettings || !expandableTextSettings.isExpanded;

  if (loading) {
    return (
      <div
        className={clsx(
          "flex h-9 flex-col justify-between *:h-2 lg:*:h-[1.25rem]",
          isDesktopExpandable ? "lg:h-12" : "lg:h-9",
          className,
        )}
      >
        {Array.from({ length: 3 }, (_, index) => (
          <LoadingSkeleton key={index} />
        ))}

        <LoadingSkeleton
          className={clsx("brand-accent-opacity-10 ml-auto max-w-[3.25rem] lg:max-w-[4.25rem]", {
            "lg:hidden": !isDesktopExpandable,
          })}
        />
      </div>
    );
  }

  return (
    text && (
      <div className={clsx("flex flex-col", className)}>
        <p
          ref={ref}
          className={clsx("max-lg:text-details", {
            "break-normal max-lg:line-clamp-3 max-lg:overflow-hidden": isTextClamped && !isDesktopExpandable,
            "line-clamp-3 overflow-hidden break-normal": isTextClamped && isDesktopExpandable,
          })}
        >
          {text}
        </p>

        {expandableTextSettings && (
          <button className="max-lg:text-details ml-auto font-bold text-brand-accent" onClick={toggleExpand}>
            <b>Ver {expandableTextSettings.isExpanded ? "menos" : "mais"}</b>
          </button>
        )}
      </div>
    )
  );
};
